import { render, staticRenderFns } from "./squeue_checkboxes.vue?vue&type=template&id=b987337e&lang=pug"
import script from "./squeue_checkboxes.vue?vue&type=script&lang=js"
export * from "./squeue_checkboxes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports